import React, { useContext, useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { BackButton, Loading } from '../../../../../Components';
import { useAptorApi } from '../../../../../Api';
import { IGridQueryRequest, OrderDirection } from '../../../../../Api/AptorApi';
import { SelectOption } from '../../../../../Components/Form/Form.types';
import { UserContext } from '../../../../../Context/UserContext/UserContext';
import Step1SelectCompanyUnit from './Overview/EditChecklistWizard/Step1SelectCompanyUnit';
import Step2EditChecklist from './Overview/EditChecklistWizard/Step2EditChecklist';

export const LawComplianceQuestions = () => {
  const { id: idParam } = useParams<{ id: string }>();
  const id = parseInt(idParam || '0');
  const { api, abortController } = useAptorApi();
  const { getCompanyUnitName } = useContext(UserContext);
  const [companyUnits, setCompanyUnits] = useState<SelectOption[]>([]);
  const [selectedUnits, setSelectedUnits] = useState<SelectOption[]>([]);
  const [loadingUnits, setLoadingUnits] = useState(true);

  useEffect(() => {
    const request: IGridQueryRequest = {
      page: 0,
      pageSize: 100,
      orderBy: 'name',
      orderDirection: OrderDirection.Ascending,
    };

    api.searchLawCompanyUnits<any>(id, request).then((result) => {
      if (abortController.current.signal.aborted) return;
      const options = (result?.data || []).map((unit: any) => ({ label: unit.name, value: unit.id }));
      setCompanyUnits(options);
      if (options.length === 1) {
        setSelectedUnits(options);
      }
      setLoadingUnits(false);
    });
  }, [api, abortController, id]);

  const handleUnitSelect = (units: SelectOption | SelectOption[]) => {
    setSelectedUnits(Array.isArray(units) ? units : [units]);
  };

  const shouldBackToUnitSelection = companyUnits.length > 1 && selectedUnits.length > 0;

  if (loadingUnits) {
    return <Loading />;
  }

  return (
    <>
      <Grid item xs={12}>
        {shouldBackToUnitSelection ? (
          <BackButton disableMargin link="" onclick={() => setSelectedUnits([])} />
        ) : (
          <BackButton disableMargin link="/law-portal/our-laws/" />
        )}
      </Grid>
      <Grid item md={9} xs={12}>
        {selectedUnits.length === 0 ? (
          <Step1SelectCompanyUnit
            onNext={handleUnitSelect}
            onBack={() => {}}
            onCancel={() => {}}
            isFirstStep
            lawId={id}
            companyUnitOptions={companyUnits}
            getCompanyUnitName={getCompanyUnitName}
          />
        ) : (
          <Step2EditChecklist
            lawId={id}
            unitId={selectedUnits[0].value as number}
            selectedUnits={selectedUnits}
            onBack={() => setSelectedUnits([])}
            onCancel={() => setSelectedUnits([])}
            onComplete={() => {}}
          />
        )}
      </Grid>
    </>
  );
};
